/**
 * Directive: dateFieldWithLabel
 */
angular.module('acme.common.directive.dateFieldWithLabel', [
  'acme.common.directive.inputFieldError',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences',
  'acme.common.directive.fieldFocus'
])
.directive('dateFieldWithLabel', ['$filter', '$timeout', 'HelpersService', 'CalendarService', 'UserPreferencesService', function($filter, $timeout, HelpersService, CalendarService, UserPreferencesService) {

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/dateFieldWithLabel/dateFieldWithLabel.tpl.html',
    scope: {
      name: '@',
      label: '@',
      icon: '@',
      useFullWidth: '@', // Used in conjunction with maxlength to prevent constrained width
      model: '=',
      modelChanged: '&',
      notifyOnBlur: '@',
      disabled: '=',
      useCancel: '@',
      setFieldFocus: '@setfieldfocus',
      fieldFocusTimeout: '@',
      maxLength: '@maxlength',
      hideLabel: '@hidelabel',
      validTest: '=validtest',
      errorMessage: '=errormessage',
      errors: '=',
      fieldName: '@',
      rows: '@',

      format: '@',
      typeLabel: '@typelabel',
      appendToBody: '@',
      showButton: '@',
      isDisabled: '=disabled',
      datePickerIndex: '@datepickerindex',
      datePickerMode: '@',
      startingDay: '=',
      ariaLabel: '@',
      minDate: '@',
      maxDate: '@',


      required: '@'
    },

    link: function($scope, $element, $attrs) {
    },

    controller: ['$scope', function($scope) {

      $scope.dateFieldWithLabel = {
        dateFormat: 'M!/d!/yyyy',
        isPreferenceLoaded: false,
        isOpen: false,
        isGroupOpen: false,
        minDate: new Date(1900, 0, 1, 0, 0, 0, 0),
        maxDate: new Date(2032, 12, 31, 23, 59, 59, 999),
        invalidDate: 'Invalid date format',

        dateOptions: {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false
        },


        setFieldFocus: $scope.setFieldFocus,
        placeholder: $scope.placeholderValue || '',
        groupTypeClass: ($scope.isPanelGroup) ? 'panel-form-group' : 'form-group',
        fieldFocusTimeout: ($scope.fieldFocusTimeout) ? $scope.fieldFocusTimeout : 0,

        label: $scope.label || ($scope.placeholderValue || ''),

        init: function() {
          watcher = $scope.$watch('errors', function() {
            if ($scope.errors && $scope.errors[$scope.fieldName]) {
              $scope.dateFieldWithLabel.error = $scope.errors[$scope.fieldName].message;
            }else{
              $scope.dateFieldWithLabel.error = false;
            }
          });

          $scope.$on('destroy', this.onDestroy);
        },



        checkValid: function() {
          var r = true;

          if ($scope.errorMessage) {
            r = (($scope.validTest !== undefined) ? $scope.validTest : true);
          } else {
            r = !this.error;
          }
          return r;
        },

        notifyOnChange: function() {
          return !($scope.notifyOnBlur && ($scope.notifyOnBlur === true || $scope.notifyOnBlur === 'true'));
        },

        onChanged: function() {
          if (this.notifyOnChange() && (typeof $scope.modelChanged === 'function')) {
            $scope.modelChanged();
          }
        },

        toggleOpen: function() {
          return (this.isOpen = !this.isOpen);
        },

        toggleGroupOpen: function() {
          return (this.isGroupOpen = !this.isGroupOpen);
        },

        getDateFormat: function() {
          return this.dateFormat;
        },

        open: function($event) {
          $event.preventDefault();
          $event.stopPropagation();

          if ($scope.showButton) {
            this.isGroupOpen = this.toggleGroupOpen();
          }else {
            this.isOpen = this.toggleOpen();
          }
        },

        clearDate: function() {
          $scope.model = null;
          if (typeof(this.focusElement) === 'function') {
            this.focusElement();
          }
        },

        onDateFormatLoad: function (e, data) {
          var self = $scope.dateFieldWithLabel;
          self.dateFormat = 'M!/d!/yyyy';
          self.dateOptions.showWeeks = false;
          self.dateOptions.startingDay = UserPreferencesService.getStartDayOfWeek();
          self.dateOptions.formatDayTitle = UserPreferencesService.getDateFormat('month', 'dateFormat');
        },

        onIsOpenUpdate: function(n, o) {
          if (n !== o && n === false) {
            $scope.dateFieldWithLabel.focusElement();
          }
        },

        onDestroy: function(e) {
          if ($scope.dateFieldWithLabel.focusTimeout) {
            $timeout.cancel($scope.dateFieldWithLabel.focusTimeout);
          }
          watcher();
        },

        onBlur: function() {
          if (typeof $scope.modelChanged === 'function') {
            $scope.modelChanged();
          }
        }

      };

      $scope.dateFieldWithLabel.init();

    }]

  };

}]);